import { render, staticRenderFns } from "./EditStudentPanel.vue?vue&type=template&id=24cf63ec&"
import script from "./EditStudentPanel.vue?vue&type=script&lang=js&"
export * from "./EditStudentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports